// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Xl4GL","skeleton-animation":"styles_skeleton-animation__2LnKx"};